module.exports = __webpack_public_path__ + "img/1516317753.5ad01dc6.jpg";